import GenericApplicationDetails from "components/Application/GenericApplicationDetails"
import { useEffect, useState } from "react"

const Details = props => {
  const [details, setdetails] = useState([])
  useEffect(()=>{
    // console.log(props.appDetails)
    let institution = []
    if (props.appDetails.accreditation_request.company_id == null) {
      institution = [
        {
          title: "Institution Name",
          value: props.appDetails.accreditation_request.institution_name,
          is_text_area: false
        },
        {
          title: "Institution Address",
          value: props.appDetails.accreditation_request.institution_address,
          is_text_area: false
        },
        {
          title: "Institution Phone",
          value: props.appDetails.accreditation_request.institution_phone,
          is_text_area: false
        },
        {
          title: "Institution Email",
          value: props.appDetails.accreditation_request.institution_email,
          is_text_area: false
        },
        {
          title: "Representative Name",
          value: props.appDetails.accreditation_request.representative_name,
          is_text_area: false
        },
        {
          title: "Representative Email",
          value: props.appDetails.accreditation_request.representative_email,
          is_text_area: false
        },
        {
          title: "Representative Phone",
          value: props.appDetails.accreditation_request.representative_phone,
          is_text_area: false
        },
      ]
    } else {
      institution = [
        {
          title: "Company Name",
          value: props.appDetails.accreditation_request.company.name,
          is_text_area: false
        },
        {
          title: "Tax Identification Number",
          value: props.appDetails.accreditation_request.company.tin,
          is_text_area: false
        },
        {
          title: "Company Phone",
          value: props.appDetails.accreditation_request.company.telephone,
          is_text_area: false
        },
        {
          title: "Company Email",
          value: props.appDetails.accreditation_request.company.email,
          is_text_area: false
        },
        {
          title: "Company Address",
          value: props.appDetails.accreditation_request.company.address,
          is_text_area: false
        },
        {
          title: "Company Contact Person Name",
          value: props.appDetails.accreditation_request.company.contact_person_name,
          is_text_area: false
        },
        {
          title: "Company Contact Person Phone",
          value: props.appDetails.accreditation_request.company.contact_person_phone,
          is_text_area: false
        },
        {
          title: "Company Contact Person Email",
          value: props.appDetails.accreditation_request.company.contact_person_email,
          is_text_area: false
        },
        {
          title: "Company Contact Person Position",
          value: props.appDetails.accreditation_request.company.contact_person_job_title,
          is_text_area: false
        },

      ]
    }

    const request = [
      {
        title: "Legal Status",
        value: props.appDetails.accreditation_request.legal_status,
        is_text_area: false
      },
      {
        title: "Project Name",
        value: props.appDetails.accreditation_request.project_name,
        is_text_area: false
      },
      {
        title: "Nomination Approach",
        value: props.appDetails.accreditation_request.nomination_approach,
        is_text_area: false
      },
      {
        title: "Project Description",
        value: props.appDetails.accreditation_request.project_description,
        is_text_area: true
      }
    ]
    
    setdetails(request.concat(institution))
  }, [])
  return (
    <>
      <h4>Nomination for Accreditation Request Details</h4>
      <GenericApplicationDetails data={details} />
    </>
  )
}

export default Details
